export default function Footer() {
  return (
    <footer className="border-t border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold leading-none tracking-tight text-foreground-950">
                全网爆闻<span className="text-primary-600">站</span>
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              一站式大V爆料源聚合平台，按领域与热度整理微博认证用户、红人与百万粉博主的公开动态，帮你快速定位一手信息来源。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-fill", "ri-twitter-x-fill", "ri-youtube-fill", "ri-rss-fill"].map((i) => (
                <a
                  key={i}
                  href="#top"
                  aria-label="社交主页"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${i} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">站内导航</h4>
            <ul className="mt-4 space-y-2.5">
              {[
                { l: "实时热榜", h: "#hot" },
                { l: "最新爆料流", h: "#feed" },
                { l: "大V账号库", h: "#bloggers" },
                { l: "爆料速递", h: "#briefing" },
                { l: "深度专题", h: "#specials" },
              ].map((x) => (
                <li key={x.l}>
                  <a href={x.h} className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                    {x.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">帮助与联系</h4>
            <ul className="mt-4 space-y-2.5">
              {[
                { l: "关于我们", h: "#about" },
                { l: "常见问题", h: "#faq" },
                { l: "内容合作", h: "#about" },
                { l: "线索投稿", h: "#faq" },
              ].map((x) => (
                <li key={x.l}>
                  <a href={x.h} className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                    {x.l}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-sm text-foreground-600">
              <a href="mailto:hi@wqx.news" className="inline-flex items-center gap-1.5 hover:text-primary-700">
                <i className="ri-mail-line text-base"></i>
                hi@wqx.news
              </a>
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-200/70 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <p>本站内容为信息聚合与来源索引，事件真实性请以当事方及权威信息为准。</p>
          <p>© 2026 全网爆闻站 · 虚构示例站点</p>
        </div>
      </div>
    </footer>
  );
}